import React from 'react';
import { PriceBox, NameBox } from '../../../components/molecules';
import { Grid, Stack } from '@mui/material';

export const PastOrderDetailRow = ({ customerName,
    orderValue,
    orderDate,
    orderRef,
}) => {
    return (
        <>
            <div className="for-shipment-landscape">
            <Grid container spacing={2}>
            <Grid item md={3}>
                <PriceBox topText={"Order Ref"} bottomText={orderRef} />
            </Grid>
            <Grid item md={3}>
                <NameBox name={customerName} heading="Customer name" />
            </Grid>
            <Grid item md={3}>
            <PriceBox topText={"Order value"}  bottomText={`\u00A3${orderValue}`} />
            </Grid>
            <Grid item md={3}>
                <PriceBox topText={"Order date"} bottomText={orderDate} />
            </Grid>
            </Grid>
            </div>
        </>
    )
}
